import { useState } from 'react';

export const useUSPExpansion = () => {
  const [expandedUSPProducts, setExpandedUSPProducts] = useState(new Set());

  const toggleUSPExpansion = (productId) => {
    setExpandedUSPProducts(prev => {
      const newSet = new Set(prev);
      if (newSet.has(productId)) {
        newSet.delete(productId);
      } else {
        newSet.add(productId);
      }
      return newSet;
    });
  };

  return {
    expandedUSPProducts,
    toggleUSPExpansion
  };
};
